import { cn } from "utils/cn";
import { RIVETAI_MARK_PATH_D, RIVETAI_MARK_VIEW_BOX } from "./RivetAIMarkLoader.constants";
import type { RivetAIMarkLoaderProps } from "./RivetAIMarkLoader.types";

export const RivetAIMarkLoader = ({ size = 112, className }: RivetAIMarkLoaderProps) => (
  <svg
    width={size}
    height={size}
    viewBox={RIVETAI_MARK_VIEW_BOX}
    className={cn("shrink-0 text-primary", className)}
    aria-hidden
  >
    <path
      className="rivetai-mark-loader-stroke"
      d={RIVETAI_MARK_PATH_D}
      fill="none"
      pathLength={1}
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={4}
    />
  </svg>
);
